import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	selectBarContainer: {
		cursor: 'pointer',
		border: theme.singleSelect.list.border,
		display: 'flex',
		background: theme.singleSelect.row.background.color.default,
		padding: `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium}`,
		alignItems: 'center',
		overflow: 'hidden',

		'&:hover': {
			background: theme.singleSelect.row.background.color.hover,
		},
		'&:first-of-type': {
			borderTopLeftRadius: theme.singleSelect.borderRadius,
			borderTopRightRadius: theme.singleSelect.borderRadius,
		},
		'&:not(:first-of-type)': {
			borderTop: 0,
		},
		'&:last-of-type': {
			borderBottomLeftRadius: theme.singleSelect.borderRadius,
			borderBottomRightRadius: theme.singleSelect.borderRadius,
		},
	},
	selectBarOptionContainer: {
		gridArea: 'selectBarOption',
		display: 'flex',
		alignItems: 'center',
	},
	contentContainer: {
		display: 'grid',
		gridTemplateAreas: "'selectBarOption labelContainer' 'textContainer textContainer'",
		gap: theme.spacing.xsmall,
		gridTemplateColumns: 'auto 1fr',
		width: '100%',

		[getFromBreakpoint('md')]: {
			gridTemplateColumns: 'auto 1fr auto',
			gridTemplateAreas:
				"'selectBarOption textContainer labelContainer' 'selectBarOption textContainer labelContainer'",
			gap: theme.spacing.medium,
		},
	},
	textContainer: {
		gridArea: 'textContainer',
		display: 'flex',
	},
	labelContainer: {
		gridArea: 'labelContainer',
		display: 'flex',
		alignItems: 'center',
		justifySelf: 'flex-end',
		justifyContent: 'space-between',
		gap: theme.spacing.tiny,

		[getFromBreakpoint('md')]: {
			flex: 1,
			justifySelf: 'flex-start',
			flexDirection: 'row-reverse',
		},
	},
	disabled: {
		pointerEvents: 'none',
		color: theme.body.foreground.color.dimmed,
	},
}));
